/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ESelectiveProcessStatus } from "../types/ESelectiveProcessStatus.ts";

/**
 * @description 1 = Registred | 2 = Approved | 3 = ReprovedDocumentation | 4 = ReprovedInterview | 5 = ReprovedExam | 6 = ReprovedPayment | 7 = Dropout |
 */
export const eSelectiveProcessStatusSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
  ])
  .describe(
    "1 = Registred | 2 = Approved | 3 = ReprovedDocumentation | 4 = ReprovedInterview | 5 = ReprovedExam | 6 = ReprovedPayment | 7 = Dropout | ",
  ) as unknown as ToZod<ESelectiveProcessStatus>;
